import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from "./Header";
import MainContent from "./MainContent";
import WeinDetails from './WeinDetails'; // Import der Wein-Details-Seite
import Login from "./Login"; 
import Statistik from "./Statistik"; // Import der Statistik-Seite
import Sommeliere from "./Sommeliere"; // Import der Sommelière-Seite
import './App.css';
import { authService } from "./services/authService";
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const [selectedMenu, setSelectedMenu] = useState("regal");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
const [username, setUsername] = useState("");

/* React.useEffect(() => {
  const token = localStorage.getItem("access_token");
  if (token) {
    setIsLoggedIn(true);
  } else {
    setIsLoggedIn(false);
  }
}, []); */

React.useEffect(() => {
  // Prüfe den Authentifizierungsstatus beim Laden der App
  const isLoggedIn = authService.isAuthenticated();
  setIsLoggedIn(isLoggedIn);
  
  if (isLoggedIn) {
    // Setze Nutzernamen aus dem gespeicherten Auth-State
    setUsername(authService.getUsername());
  }
}, []);


  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <div className="d-flex flex-column" style={{ height: "100vh" }}>
        {/* Header bleibt in allen Routen sichtbar */}
        <Header 
          onSelectMenu={setSelectedMenu}
          isLoggedIn={isLoggedIn}
          setIsLoggedIn={setIsLoggedIn}
          username={username}
          setUsername={setUsername}
        />
        <div className="d-flex flex-column p-4" style={{ flex: 1 }}>
        <Routes>
            {/* Hauptinhalt (Weinliste) */}
           {/* <Route path="/" element={<MainContent selectedMenu={selectedMenu} />} />*/}
           <Route path="/login" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
           <Route path="/" element={<MainContent selectedMenu="regal" />} />
        <Route path="/weine" element={<MainContent selectedMenu="weine" />} />
        <Route path="/einkauf" element={
          <ProtectedRoute>
            <MainContent selectedMenu="einkauf" />
            </ProtectedRoute>} />
        <Route path="/probe" element={
          <ProtectedRoute>
            <MainContent selectedMenu="probe" />
            </ProtectedRoute>} />
        <Route path="/statistik" element={
          <ProtectedRoute>
            <Statistik />
            </ProtectedRoute>} />
        <Route path="/sommeliere" element={
          <ProtectedRoute>
            <Sommeliere />
            </ProtectedRoute>} />
            {/* Wein-Details Seite */}
            <Route path="/wein/:id" element={<WeinDetails isLoggedIn={isLoggedIn} />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
